import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Page} from 'src/app/config/navigation.config';
import {ModuleAccessService} from '../../modules-access/module-access.service';

@Component({
    selector: 'app-core-accordion-menu',
    templateUrl: './accordion-menu.component.html',
    styleUrls: ['./accordion-menu.component.scss'],
    standalone: false
})
export class AccordionMenuComponent implements OnInit {

  @Input() rootNavigation: Page[];
  expand = true;

  constructor(public router: Router, public moduleAccessService: ModuleAccessService) {
  }

  ngOnInit(): void {
  }

}
